<form action="regCaseForm" [formGroup]="form">
  <mat-accordion>
    <!-- Booking Type -->
    <mat-radio-group
      formControlName="bookingType"
      aria-label="Booking type"
      class="booking-type-group"
    >
      <mat-radio-button class="label-button" value="newBooking" color="primary">
        <span class="mat-radio-label-content"> New booking</span>
      </mat-radio-button>

      <mat-radio-button class="label-button" value="extension" color="primary">
        <span class="mat-radio-label-content">Extension</span>
      </mat-radio-button>
    </mat-radio-group>

    <!-- EXTENSION MODE -->
    <ng-container *ngIf="form.get('bookingType')?.value === 'extension'">
      <div formGroupName="extension">
        <mat-expansion-panel expanded hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>Extension Details</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="grid grid-2">
            <mat-form-field appearance="outline">
              <mat-label>Case number</mat-label>
              <input matInput formControlName="caseNumber" required />
              @if (form.get('extension.caseNumber')?.errors?.['required']) {
              <mat-error>Case number is Required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Claim number</mat-label>
              <input
                matInput
                formControlName="claimNumber"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="11"
                minlength="11"
                required
              />
              @if (form.get('extension.claimNumber')?.errors?.['required']) {
              <mat-error>Claim Number is Required</mat-error>
              } @if ( form.get('extension.claimNumber')?.hasError('pattern') ||
              form.get('extension.claimNumber')?.hasError('minlength') ||
              form.get('extension.claimNumber')?.hasError('maxlength') ) {
              <mat-error>Claim Number must contain exactly 11 digits</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-2">
            <mat-form-field appearance="outline">
              <mat-label>Extension from</mat-label>
              <input
                matInput
                [matDatepicker]="extensionFromPicker"
                formControlName="checkInDate"
                [min]="today"
                required
                (focus)="extensionFromPicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="extensionFromPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #extensionFromPicker></mat-datepicker>

              @if (form.get('extension.checkInDate')?.errors?.['required']) {
              <mat-error>Extension start date is Required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Extension to</mat-label>
              <input
                matInput
                [matDatepicker]="extensionToPicker"
                [min]="form.get('extension.checkInDate')?.value || today"
                formControlName="checkOutDate"
                required
                (focus)="extensionToPicker.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="extensionToPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #extensionToPicker></mat-datepicker>
              @if
              (form.get('extension.checkOutDate')?.hasError('matDatepickerMin'))
              {
              <mat-error
                >Extension end date must be later than Extension start
                Date</mat-error
              >
              } @if (form.get('extension.checkOutDate')?.errors?.['required']) {
              <mat-error>Extension end date is Required</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-1">
            <mat-form-field appearance="outline">
              <mat-label>Claims consultant requesting it</mat-label>
              <input matInput formControlName="requestingConsultant" required />
              @if
              (form.get('extension.requestingConsultant')?.errors?.['required'])
              {
              <mat-error>Consultant name is Required</mat-error>
              }
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </div>
    </ng-container>

    <!-- NEW BOOKING MODE -->
    <ng-container *ngIf="form.get('bookingType')?.value === 'newBooking'">
      <div formGroupName="newBooking">
        <mat-expansion-panel
          expanded
          (closed)="panelHolder.open()"
          hideToggle
          #panelHolder="matExpansionPanel"
        >
          <mat-expansion-panel-header>
            <mat-panel-title> Policy Holder Details</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="grid grid-3">
            <mat-form-field appearance="outline">
              <mat-label>Policy Holder First Name</mat-label>
              <input
                matInput
                formControlName="policyHolderFirstName"
                required
              />
              @if
              (form.get('newBooking.policyHolderFirstName')?.errors?.['required'])
              {
              <mat-error>Policy Holder First Name is required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Policy Holder Surname</mat-label>
              <input matInput formControlName="policyHolderSurname" required />
              @if
              (form.get('newBooking.policyHolderSurname')?.errors?.['required'])
              {
              <mat-error>Policy Holder is Surname Required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Date of Birth</mat-label>
              <input
                matInput
                [matDatepicker]="policyHolderDateOfBirth"
                formControlName="policyHolderDateOfBirth"
                required
                (focus)="policyHolderDateOfBirth.open()"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="policyHolderDateOfBirth"
              ></mat-datepicker-toggle>
              <mat-datepicker #policyHolderDateOfBirth></mat-datepicker>

              @if
              (form.get('newBooking.policyHolderDateOfBirth')?.errors?.['required'])
              {
              <mat-error>Date of Birth is Required </mat-error>
              } @if
              (form.get('newBooking.policyHolderDateOfBirth')?.hasError('underage'))
              {
              <mat-error> Guest must be at least 18 years old. </mat-error>
              } @if
              (form.get('newBooking.policyHolderDateOfBirth')?.errors?.['tooOld']
              ||
              form.get('newBooking.policyHolderDateOfBirth')?.errors?.['invalidDate'])
              {
              <mat-error> Please enter a valid date.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-3">
            <mat-form-field appearance="outline">
              <mat-label>Policy Holder Phone Number</mat-label>
              <input matInput formControlName="policyHolderPhone" required />
              @if
              (form.get('newBooking.policyHolderPhone')?.errors?.['required']) {
              <mat-error>Phone Number is Required</mat-error>
              } @if
              (form.get('newBooking.policyHolderPhone')?.errors?.['pattern']) {
              <mat-error>Invalid Phone</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Policy Holder Alt Phone Number</mat-label>
              <input matInput formControlName="policyHolderAltPhone" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Policy Holder Email</mat-label>
              <input matInput formControlName="policyHolderEmail" required />
              @if
              (form.get('newBooking.policyHolderEmail')?.errors?.['required']) {
              <mat-error>Email is Required</mat-error>
              } @if
              (form.get('newBooking.policyHolderEmail')?.errors?.['email']) {
              <mat-error>Invalid Email</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-3">
            <mat-form-field appearance="outline">
              <mat-label>Nightly Budget</mat-label>
              <input
                type="text"
                inputmode="numeric"
                matInput
                formControlName="nightlyBudget"
                required
              />
              @if ( form.get('newBooking.nightlyBudget')?.touched &&
              form.get('newBooking.nightlyBudget')?.errors?.['pattern'] ) {
              <mat-error>Nightly Budget must contain numbers only</mat-error>
              } @if (form.get('newBooking.nightlyBudget')?.errors?.['required'])
              {
              <mat-error>Nightly Budget is Required </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Total 10% Limit</mat-label>
              <input
                matInput
                type="text"
                inputmode="numeric"
                formControlName="totalTenPercentLimit"
                required
              />
              @if ( form.get('newBooking.totalTenPercentLimit')?.touched &&
              form.get('newBooking.totalTenPercentLimit')?.errors?.['pattern'] )
              {
              <mat-error>Total 10% Limit must contain numbers only</mat-error>
              } @if
              (form.get('newBooking.totalTenPercentLimit')?.errors?.['required'])
              {
              <mat-error>Total 10% Limit is Required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Claim Number </mat-label>
              <input
                matInput
                formControlName="claimNumber"
                required
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="11"
                minlength="11"
              />
              @if (form.get('newBooking.claimNumber')?.errors?.['required']) {
              <mat-error>Claim Number is Required</mat-error>
              } @if ( form.get('newBooking.claimNumber')?.hasError('pattern') ||
              form.get('newBooking.claimNumber')?.hasError('minlength') ||
              form.get('newBooking.claimNumber')?.hasError('maxlength') ) {
              <mat-error>Claim Number must contain exactly 11 digits</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="grid grid-1">
            <span>Consent*</span>
            <mat-checkbox formControlName="consentEmail" color="primary"
              >Email</mat-checkbox
            >
            <mat-checkbox formControlName="consentSMS" color="primary"
              >SMS</mat-checkbox
            >

            <!-- form-level validator (scoped in TS to newBooking only) -->
            @if (form.hasError('atLeastOne') && (form.dirty || form.touched)) {
            <mat-error class="mat-error"> Consent Type is Required </mat-error>
            }
          </div>
        </mat-expansion-panel>

        <!-- Incident -->
        <mat-accordion [multi]>
          <mat-expansion-panel
            expanded
            (closed)="panelIncident.open()"
            hideToggle
            #panelIncident="matExpansionPanel"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Kind of Incident</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="grid grid-2">
              <mat-form-field appearance="outline">
                <mat-label>Claim Type</mat-label>
                <mat-select formControlName="claimType" required>
                  @for (item of claimTypesList(); track $index) {
                  <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
                @if (form.get('newBooking.claimType')?.errors?.['required']) {
                <mat-error>Claim Type is Required </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Incident Date</mat-label>
                <input
                  matInput
                  [max]="today"
                  [matDatepicker]="incidentPicker"
                  formControlName="incidentDate"
                  required
                  (focus)="incidentPicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="incidentPicker"
                  required
                ></mat-datepicker-toggle>
                <mat-datepicker #incidentPicker></mat-datepicker>

                @if (form.get('newBooking.incidentDate')?.errors?.['required'])
                {
                <mat-error>Incident Date is Required </mat-error>
                }

                <mat-error
                  *ngIf="
                    form.get('newBooking.incidentDate')?.hasError('futureDate')
                  "
                >
                  Incident Date Cannot Be in The Future
                </mat-error>
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <mat-accordion>
          <mat-expansion-panel
            expanded
            (closed)="panelDetails.open()"
            hideToggle
            #panelDetails="matExpansionPanel"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Accomodation Details</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="grid grid-05">
              <mat-form-field appearance="outline">
                <mat-label>Insured Address</mat-label>
                <input
                  #insuredInput
                  id="insuredAddress"
                  matInput
                  formControlName="insuredAddress"
                  required
                  [value]="
                    form.get('newBooking.insuredAddress')?.value
                      ?.FormattedAddress || ''
                  "
                  (input)="onAddressChange(insuredInput, 'insuredAddress')"
                />
                @if
                (form.get('newBooking.insuredAddress')?.errors?.['required']) {
                <mat-error>Insured Address is Required</mat-error>
                } @if
                (form.get('newBooking.insuredAddress')?.errors?.['missingState'])
                {
                <mat-error>
                  Please select a valid address from the list</mat-error
                >
                }
              </mat-form-field>
            </div>

            <div class="grid grid-2">
              <mat-form-field appearance="outline">
                <mat-label>Requested Location</mat-label>
                <input
                  #requestedInput
                  id="requestedLocation"
                  matInput
                  formControlName="requestedLocation"
                  (input)="onAddressChange(requestedInput, 'requestedLocation')"
                  required
                />

                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="sameAsInsured('requestedLocation')"
                  aria-label="Locked"
                >
                  <mat-icon>lock</mat-icon>
                </button>

                @if
                (form.get('newBooking.requestedLocation')?.errors?.['required'])
                {
                <mat-error>Requested Location is Required</mat-error>
                } @if
                (form.get('newBooking.requestedLocation')?.errors?.['missingState'])
                {
                <mat-error>
                  Please select a valid address from the list</mat-error
                >
                }
              </mat-form-field>

              <mat-checkbox
                color="primary"
                [checked]="sameAsInsured('requestedLocation')"
                (change)="
                  toggleSameAsInsured('requestedLocation', $event.checked)
                "
              >
                Same as Insured Address
              </mat-checkbox>
            </div>

            <div class="grid grid-2">
              <mat-form-field appearance="outline">
                <mat-label>Check-in Date</mat-label>
                <input
                  matInput
                  [min]="today"
                  [matDatepicker]="checkInPicker"
                  formControlName="checkInDate"
                  required
                  (focus)="checkInPicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="checkInPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #checkInPicker></mat-datepicker>

                @if (form.get('newBooking.checkInDate')?.errors?.['required']) {
                <mat-error>Check-in Date is Required</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Check-out Date</mat-label>
                <input
                  matInput
                  [min]="form.get('newBooking.checkInDate')?.value || today"
                  [matDatepicker]="checkOutPicker"
                  formControlName="checkOutDate"
                  required
                  (focus)="checkOutPicker.open()"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="checkOutPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #checkOutPicker></mat-datepicker>

                @if
                (form.get('newBooking.checkOutDate')?.hasError('matDatepickerMin'))
                {
                <mat-error
                  >Check-out Date must be later than Check-in Date</mat-error
                >
                } @if
                (form.get('newBooking.checkOutDate')?.errors?.['required']) {
                <mat-error>Check-out Date is Required</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="grid grid-05">
              <mat-form-field appearance="outline">
                <mat-label>Accommodation Requirement</mat-label>
                <mat-select formControlName="incidentType" required>
                  @for (item of accomodationRequirementList(); track $index) {
                  <mat-option
                    [value]="item"
                    [disabled]="
                      (getDateDiff() > 7 && item === 'Short Term') ||
                      (getDateDiff() <= 7 && item === 'Long Term')
                    "
                  >
                    {{ item }}
                  </mat-option>
                  }
                </mat-select>
                @if (form.get('newBooking.incidentType')?.errors?.['required'])
                {
                <mat-error>Accommodation Requirement is Required </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="grid grid-3">
              <mat-form-field appearance="outline">
                <mat-label>No. Car Parks</mat-label>
                <input matInput type="number" formControlName="noCarParks" />
                @if (form.get('newBooking.noCarParks')?.errors?.['min']) {
                <mat-error>Number of Car Parks Must Be Positive</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Vehicle Regos</mat-label>
                <input matInput type="text" formControlName="vehicleRegos" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Mobility Issues</mat-label>
                <input matInput type="text" formControlName="mobilityIssues" />
              </mat-form-field>
            </div>

            <div class="grid grid-3">
              <mat-form-field appearance="outline">
                <mat-label>No. Adults</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="noAdults"
                  required
                />
                @if (form.get('newBooking.noAdults')?.errors?.['min']) {
                <mat-error>Number of Adults Must Be Positive</mat-error>
                } @if (form.get('newBooking.noAdults')?.errors?.['required']) {
                <mat-error>Number of Adults is Required</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> No. Children (0-2)</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="noChildrenSmall"
                />
                @if (form.get('newBooking.noChildrenSmall')?.errors?.['min']) {
                <mat-error>Number of Children (0-2) Must Be Positive</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> No. Children (3-14)</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="grownUpChildren"
                />
                @if (form.get('newBooking.grownUpChildren')?.errors?.['min']) {
                <mat-error
                  >Number of Children (3-14) Must Be Positive</mat-error
                >
                }
              </mat-form-field>
            </div>

            <div class="grid grid-4">
              <mat-form-field appearance="outline">
                <mat-label> Dogs</mat-label>
                <input matInput type="number" formControlName="dogs" />
                @if (form.get('newBooking.dogs')?.errors?.['min']) {
                <mat-error>Number of Dogs Must Be Positive</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Dog Breeds</mat-label>
                <input matInput type="text" formControlName="dogBreeds" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Cats</mat-label>
                <input matInput type="number" formControlName="cats" />
                @if (form.get('newBooking.cats')?.errors?.['min']) {
                <mat-error>Number of Cats Must Be Positive</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Cat Breeds</mat-label>
                <input matInput type="text" formControlName="catBreeds" />
              </mat-form-field>
            </div>

            <div class="grid grid-1">
              <mat-form-field appearance="outline">
                <mat-label>Additional Notes</mat-label>
                <textarea matInput formControlName="additionalNotes"></textarea>
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Key client -->
        <mat-accordion>
          <mat-expansion-panel
            expanded
            (closed)="panelClient.open()"
            hideToggle
            #panelClient="matExpansionPanel"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Key Client</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="grid grid-4">
              <mat-form-field appearance="outline">
                <mat-label>Key Client</mat-label>
                <mat-select
                  formControlName="keyClient"
                  name="keyClient"
                  required
                >
                  @for (keyClient of keyClientList(); track keyClient) {
                  <mat-option [value]="keyClient">{{ keyClient }}</mat-option>
                  }
                </mat-select>
                @if (form.get('newBooking.keyClient')?.errors?.['required']) {
                <mat-error>Key Client is Required</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Claim Consultant First Name </mat-label>
                <input matInput formControlName="claimConsultantFirstName" />
                @if
                (form.get('newBooking.claimConsultantFirstName')?.errors?.['required'])
                {
                <mat-error>Claim Consultant First Name is Required</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Claim Consultant Surname</mat-label>
                <input matInput formControlName="claimConsultantSurname" />
                @if
                (form.get('newBooking.claimConsultantSurname')?.errors?.['required'])
                {
                <mat-error>Claim Consultant Surname is Required</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Ext</mat-label>
                <input matInput formControlName="claimConsultantExt" />
              </mat-form-field>
            </div>

            <div class="grid grid-05">
              <mat-form-field appearance="outline">
                <mat-label>Claim Consultant Email</mat-label>
                <input
                  matInput
                  formControlName="claimConsultantEmail"
                  value="home@autogeneral.com.au"
                  readonly=""
                />
              </mat-form-field>
            </div>

            <div class="grid grid-1">
              <mat-form-field appearance="outline">
                <mat-label>Additional Notes</mat-label>
                <textarea
                  matInput
                  formControlName="claimConsultantAdditionalNotes"
                ></textarea>
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </ng-container>
  </mat-accordion>

  <div class="btns">
    <button
      class="btn"
      mat-stroked-button
      color="primary"
      type="button"
      (click)="reset()"
    >
      Reset
    </button>

    <button
      class="btn"
      mat-raised-button
      color="primary"
      type="submit"
      (click)="submit()"
      [disabled]="form.invalid || isSubmittingInProgress()"
    >
      <ng-container *ngIf="!isSubmittingInProgress(); else loadingTpl">
        Submit
      </ng-container>
    </button>

    <ng-template #loadingTpl> Loading... </ng-template>
  </div>
</form>
